import CreateAssignment from "./CreateAssignment";

export default CreateAssignment;
